var _line, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 478,
    viewBox: "0 0 2 478",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 4.37114e-8,
    x2: 0.999979,
    y2: 478,
    stroke: "url(#paint0_linear_12294_11966)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12294_11966",
    x1: -0.8,
    y1: -3.49753e-8,
    x2: -0.800133,
    y2: 478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0596684,
    stopColor: "#4EF076",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495289,
    stopColor: "#48F7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939508,
    stopColor: "#4EF076",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/Line.7261f98b8cffc657c6959800e2dac8fe.svg";
export { ForwardRef as ReactComponent };